// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__Ppm9m","info":"PatientInfo_info__2HltO"};